import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import { ERROR_CODES } from "../config/apiConfig";
import { AUTH_MESSAGES } from "../config/authApi.config";
import type { SerializedError } from "@reduxjs/toolkit/react";

export const handleAuthError = (error: { message?: string; status?: number }): string => {
    switch (error.status) {
        case ERROR_CODES.UNAUTHORIZED:
            return AUTH_MESSAGES.LOGIN_ERROR;
        case ERROR_CODES.SERVER_ERROR:
            return AUTH_MESSAGES.NETWORK_ERROR;
        case ERROR_CODES.FORBIDDEN:
            return AUTH_MESSAGES.FORBIDDEN;
        case ERROR_CODES.NOT_FOUND:
            return AUTH_MESSAGES.NOT_FOUND;
        default:
            return error.message || AUTH_MESSAGES.GENERIC_ERROR;
    }
};

export function getErrorMessage(error: FetchBaseQueryError | SerializedError | null | undefined): string {
    if (!error) return "";

    if ("data" in error && typeof error.data === "object" && error.data !== null) {
        return (error.data as any).message || "An unknown error occurred.";
    }

    if ("message" in error) {
        return error.message || "An unknown error occurred.";
    }

    return "Something went wrong.";
}
